import { createAction } from 'redux-actions';

import { generateApiActions } from './action-helpers';

const types = {
  INVITE_USER: 'INVITE_USER',
  INVITE_USER_FETCHED: 'INVITE_USER_FETCHED',
  ACCEPT_INVITATIONS_REQUEST: 'ACCEPT_INVITATIONS_REQUEST',
  ACCEPT_INVITATIONS_END: 'ACCEPT_INVITATIONS_END',
  CANCEL_USER_INVITATION: 'CANCEL_USER_INVITATION',
};

export const {
  inviteUserRequest,
  inviteUserSuccess,
  inviteUserFailure,
} = generateApiActions(types.INVITE_USER);

export const inviteUserFetched = createAction(types.INVITE_USER_FETCHED);

export const acceptInvitationsRequest = createAction(types.ACCEPT_INVITATIONS_REQUEST);
export const acceptInvitationsEnd = createAction(types.ACCEPT_INVITATIONS_END);

export const cancelUserInvitation = createAction(types.CANCEL_USER_INVITATION);



// WEBPACK FOOTER //
// ./src/redux/actions/invitations.js